const displayCat = function() { 
    if (document.getElementById('select-display-cat')) {
        let cat = document.getElementById('select-display-cat').value;
        const articles = document.querySelectorAll('.article');
        if (cat === "all") {
            for (let i = 0; i < articles.length; i++) {  
                articles[i].style.display = 'block';
                articles[i].classList.add('yes');
            }
        }
        else {
            for (let i = 0; i < articles.length; i++) {  
                if (!articles[i].classList.contains(cat)) {
                    articles[i].style.display = 'none';
                    articles[i].classList.remove('yes');
                }
                else {
                    articles[i].style.display = 'block';
                    articles[i].classList.add('yes');
                }
            }
        }
        let numberTemplates = document.getElementsByClassName('yes').length;
        if (numberTemplates > 1) {
            document.getElementsByClassName('woocommerce-result-count')[0].innerHTML = numberTemplates + " résultats affichés";
        }
        else {
            document.getElementsByClassName('woocommerce-result-count')[0].innerHTML = numberTemplates + " résultat affiché";
        }
    }
}
  
addFunctionOnWindowLoad(displayCat);